import type { IState } from '~/types/country/models'
import { CountryIds } from '~/services/selectLists/countries'

export function State(o: IState): IState {
  const fn = '[cynqueModules/dataObjects/State.ts] State |'
  if (!o) {
    throw new Error(`${fn} State called with falsey state`)
  }

  const obj = { ...o }
  obj.label = obj.countryId === CountryIds.UNITED_STATES ? o.iso2 : o.name
  return obj
}
